// AUTO-EXTRACTED real exam content (one representative published item per task type)
// Source: backend/content/{celpip,pte}/items. Regenerate with tools/extract_screens.py.
export const EXAM_SCREENS = {
 "celpip": {
  "reading_p4_viewpoints": {
   "mode": "reading",
   "section": "reading",
   "audio": false,
   "passage": "Should Fairlawn Street become a car-free pedestrian block?\n\nThis summer, the city will close the two-block stretch of Fairlawn Street to traffic on weekends, turning it over to walkers, patios, and market stalls. If foot traffic and merchant revenue rise, council may make the closure permanent and year-round. The proposal has divided the people who live and work there.\n\nCouncillor Anneli Virtanen, who introduced the…",
   "prompt": "What is Councillor Virtanen's central argument for the closure?",
   "options": [
    "The closure is a reversible trial that risks little",
    "Merchants on Fairlawn Street have demanded the change",
    "Cars cause most of the street's current problems",
    "The street needs permanent rebuilding to attract shoppers"
   ],
   "answerIndex": 0
  },
  "listening_p6_viewpoints": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "Host: This fall, city council is weighing what to do with the Greenwood municipal golf course, a ninety-acre stretch on the east side that has run at a loss for six straight years. The proposal on the table would close the course and split the land roughly in half: one portion becomes public parkland with walking trails and a pond, and the other becomes a mix of townhomes and mid-rise apartments. The arguments are…",
   "prompt": "What is the speaker mainly doing in this segment?",
   "options": [
    "Announcing that council has voted to close the Greenwood golf course",
    "Urging listeners to join the Greenwood Golfers' Association",
    "Laying out both sides of a land-use proposal and then offering a qualified personal view",
    "Explaining how the Lindholt district managed its course conversion"
   ],
   "answerIndex": 2
  },
  "writing_t1_email": {
   "mode": "typed",
   "section": "writing",
   "audio": false,
   "passage": "",
   "prompt": "A friend who is hosting their parents' fortieth anniversary dinner next month has asked you for help finding a caterer. Last spring you hired a local catering company for your own family gathering and were very happy…",
   "words": "150-200 words"
  },
  "reading_p1_correspondence": {
   "mode": "reading",
   "section": "reading",
   "audio": false,
   "passage": "Dear Mr. Schreiber,\n\nI am writing to request your permission to install a window air-conditioning unit in my apartment, Suite 412, for the upcoming summer season. I have rented here for three years now, and I want to make sure I follow the building's proper process before purchasing or installing anything.\n\nMy reason for the request is partly medical. My doctor has advised that the heat in my unit, which faces west…",
   "prompt": "What is the main purpose of this email?",
   "options": [
    "To complain that the apartment becomes too hot in summer",
    "To request approval to install a window air-conditioning unit",
    "To report that a portable fan has stopped working",
    "To ask for a transfer to a cooler unit in the building"
   ],
   "answerIndex": 1
  },
  "writing_t2_survey": {
   "mode": "typed",
   "section": "writing",
   "audio": false,
   "passage": "",
   "prompt": "Your local community centre has space and budget to add one new free evening program for adults this fall, and it is asking residents to choose between two options in a short survey. Read the two options below and write…",
   "words": "150-200 words"
  },
  "speaking_t2_experience": {
   "mode": "speak",
   "section": "speaking",
   "audio": false,
   "prompt": "Talk about a time when a sudden power outage forced you to change your plans for the day. Describe what you were trying to do and how you adjusted. In your response, you may want to consider the following:\n\n- Where were you and what were you in the middle of doing?\n- What happened, and how did you…",
   "passage": "",
   "prep": null,
   "rec": null
  },
  "listening_p3_information": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "W: You've reached the Juniper Neighbourhood Association. This is Imani.\nM: Hi Imani. My name's Yusuke. I saw a flyer about your winter sidewalk program and I'd like to sign up to help out.\nW: Oh, the Snow Angels program, wonderful. So just to set expectations, volunteers don't shovel for the whole street. You're matched with one or two older residents nearby, and you clear their walkway and steps after a…",
   "prompt": "What is a volunteer in the Snow Angels program responsible for clearing?",
   "options": [
    "The entire street's sidewalks",
    "The walkway and steps of one or two assigned residents",
    "Only the corner lots flagged by the city",
    "Any property where a resident requests help that day"
   ],
   "answerIndex": 1
  },
  "speaking_t4_predictions": {
   "mode": "image",
   "section": "speaking",
   "audio": false,
   "prompt": "Look at the scene. What do you think will happen next? Explain your prediction and your reasons.",
   "diagram": null,
   "scene": "On a warm summer day at a busy outdoor market, a young woman in a long white sundress stands chatting near a striped food cart. Beside her, a boy of about six has just bumped her elbow while reaching for a balloon. The chocolate ice cream cone slips from his fingers and tilts in midair, the scoop…",
   "imageRef": "celpip-s-t4-p20.png"
  },
  "speaking_t3_scene": {
   "mode": "image",
   "section": "speaking",
   "audio": false,
   "prompt": "Describe the scene in as much detail as you can. Talk about who is there, what they are doing, and what you can see around them.",
   "diagram": null,
   "scene": "It is a sunny afternoon outside the elementary school, and the pickup zone is packed. A line of cars idles along the curb, and a woman in a yellow vest waves the next vehicle forward. Two boys in matching soccer jerseys race down the front steps toward a parked minivan. Near a green bench, a father…",
   "imageRef": "celpip-s-t3-p20.png"
  },
  "speaking_t1_advice": {
   "mode": "speak",
   "section": "speaking",
   "audio": false,
   "prompt": "Your cousin co-owns a small lakeside cottage with two siblings. The cottage has been in the family for years and holds good memories, but it needs an expensive new roof and septic system, and the siblings rarely agree on schedules or upkeep. One sibling now wants to sell and split the money; your…",
   "passage": "",
   "prep": null,
   "rec": null
  },
  "speaking_t6_difficult": {
   "mode": "speak",
   "section": "speaking",
   "audio": false,
   "prompt": "You help organize a charity bake sale for your community centre. The event has been cancelled at the last minute because the venue's kitchen failed an inspection. Two people are expecting to hear from you: an enthusiastic volunteer who already baked dozens of items and bought ingredients with her…",
   "passage": "",
   "prep": null,
   "rec": null
  },
  "speaking_t5_compare": {
   "mode": "speak",
   "section": "speaking",
   "audio": false,
   "prompt": "You and your partner want to make commuting to work cheaper and easier this year. You have found two options and need to choose one together. Your partner prefers Option B, the monthly transit pass. You believe Option A, buying two used commuter bikes, is the better choice. Try to convince your…",
   "passage": "",
   "prep": null,
   "rec": null
  },
  "speaking_t7_opinion": {
   "mode": "speak",
   "section": "speaking",
   "audio": false,
   "prompt": "Some Canadian cities are considering rules that would limit how many new drive-through restaurants can be built, arguing they cause traffic, idling pollution, and discourage walkable neighbourhoods. Others say drive-throughs are convenient for parents, shift workers, and people with mobility…",
   "passage": "",
   "prep": null,
   "rec": null
  },
  "reading_p2_diagram": {
   "mode": "diagram",
   "section": "reading",
   "audio": false,
   "passage": "Hi Oluwaseun,\n\nGood news, the fall flyer from Fairhaven finally landed in my inbox. After that mug I cracked at the community fair, I promised myself I'd actually learn to do this properly, so I'm signing up this week before it books out.\n\nThe scheduling is what I keep circling back to. I have my standing physiotherapy appointment every Thursday evening through November, so anything on a Thursday is a non-starter no…",
   "prompt": "Complete the sentence: Given Fola's level, schedule, and what she wants from a class, the workshop that fits is ______.",
   "options": [
    "Glaze & Finish",
    "Open Wheel Lab",
    "Wheel Basics",
    "Handbuilding Studio"
   ],
   "answerIndex": 2,
   "diagram": {
    "kind": "table",
    "title": "Fairhaven Clay Studio: Fall Pottery Workshops",
    "columns": [
     "Workshop",
     "Level",
     "Day & Time",
     "Fee (6 weeks)",
     "Includes"
    ],
    "rows": [
     [
      "Wheel Basics",
      "Beginner",
      "Tue 6:30-8:30 pm",
      "$185",
      "Clay, one firing"
     ],
     [
      "Handbuilding Studio",
      "Beginner",
      "Sat 10:00 am-12:00 pm",
      "$170",
      "Clay, tool kit"
     ],
     [
      "Glaze & Finish",
      "Intermediate",
      "Thu 6:30-8:30 pm",
      "$195",
      "Glazes, two firings"
     ],
     [
      "Open Wheel Lab",
      "Intermediate",
      "Sun 1:00-4:00 pm",
      "$210",
      "Studio access only"
     ]
    ],
    "notes": [
     "Members of the Fairhaven Arts Guild pay 20% less on any workshop.",
     "Glaze & Finish is open only to students who have completed Wheel Basics or Handbuilding Studio with us.",
     "Open Wheel Lab provides no instruction; participants bring their own project ideas and clay.",
     "The studio is closed for the Thanksgiving long weekend; the missed Thursday session is rescheduled to the following Friday."
    ]
   }
  },
  "listening_p5_discussion": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "W1 (Ji-woo): All right, so this is the big one: Grandpa Magnus turns ninety in August, and the whole family wants a real celebration. I think we should rent the lakeside hall in town. It holds a hundred people, and everyone could actually fit for once.\nM1 (Mehdi): A hundred people is exactly what worries me. Last reunion we did the hall and Grandpa was exhausted by eight o'clock. He told me afterward he barely got…",
   "prompt": "What does Ji-woo suggest at the beginning of the discussion?",
   "options": [
    "Holding the celebration over a full weekend",
    "Renting the lakeside hall in town",
    "Keeping the gathering at Aunt Ines's farm",
    "Hiring a caterer for the main dinner"
   ],
   "answerIndex": 1
  },
  "listening_p1_problem_solving": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "M: Good afternoon, this is Okonkwo speaking from Riverbend Pharmacy. Am I talking to Mrs. Halvorsen?\nW: Yes, that's me. You left a message about my prescription?\nM: I did. There's a small problem with the refill your doctor sent over for your blood pressure medication. The clinic faxed us the order this morning, but they prescribed the ninety-day supply, and your insurance will only cover a thirty-day refill at a…",
   "prompt": "What is the main problem the pharmacist is calling about?",
   "options": [
    "The clinic faxed the prescription to the wrong pharmacy",
    "The woman's insurance will only cover a thirty-day refill at a time",
    "The blood pressure medication is out of stock at the pharmacy",
    "The doctor prescribed the wrong dosage of medication"
   ],
   "answerIndex": 1
  },
  "listening_p2_daily_life": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "W: Hey, Lukas. Did you get that flyer from the city about the new sidewalk bylaw?\nM: The snow-clearing one? Yeah, it was tucked in my mailbox this morning. I skimmed it. Something about clearing your stretch of sidewalk within twenty-four hours of a snowfall?\nW: That's the one. Last winter it was forty-eight hours, so they've tightened it. And the part that surprised me is the fines. First time they just send a…",
   "prompt": "What change to the snow-clearing rule does the woman point out?",
   "options": [
    "The deadline has been shortened from forty-eight hours to twenty-four",
    "Clearing the sidewalk is now optional for most residents",
    "The city will now clear the sidewalks itself",
    "The deadline has been extended to forty-eight hours"
   ],
   "answerIndex": 0
  },
  "speaking_t8_unusual": {
   "mode": "image",
   "section": "speaking",
   "audio": false,
   "prompt": "While walking past a hardware store, you spot an unusual old coin-operated ride sitting on the sidewalk with a 'free to a good home' sign on it. You think a friend who collects vintage items might…",
   "diagram": null,
   "scene": "",
   "imageRef": null
  },
  "listening_p4_news_item": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "Reporter: The old Lansdowne Theatre, which sat empty for more than a decade, opened its doors last night in a new role: a covered food market featuring fourteen local vendors. The 1920s cinema stopped showing films in 2009 and was nearly torn down three years ago, until a group of restaurant owners led by chef Olusegun Bankole bought the building and spent two years restoring it. The project cost about 6 million…",
   "prompt": "What is the main news being reported?",
   "options": [
    "A historic theatre has been demolished to make room for a market",
    "A former cinema has reopened as a local food market",
    "The city has awarded a heritage grant to restore a theatre",
    "A group of restaurant owners has bought an empty building"
   ],
   "answerIndex": 1
  },
  "reading_p3_information": {
   "mode": "reading",
   "section": "reading",
   "audio": false,
   "passage": "A. When the province first announced its rural connectivity rebate, the goal was simple: lower the upfront cost of installing high-speed internet for homes far from existing cable lines. Households more than two kilometres from a serviced road can apply once installation is complete, and the rebate covers up to sixty percent of equipment and labour. Funding comes from a levy collected on every retail phone and…",
   "prompt": "Statement: The money for the rebate is raised from charges on customers' communication bills, not from ordinary taxes.",
   "options": [
    "Paragraph A",
    "Paragraph B",
    "Paragraph C",
    "Paragraph D"
   ],
   "answerIndex": 0
  }
 },
 "pte": {
  "pte_repeat_sentence": {
   "mode": "speak",
   "section": "speaking",
   "audio": true,
   "prompt": "You will hear a sentence. Please repeat the sentence exactly as you hear it.",
   "passage": "",
   "prep": 0,
   "rec": 15
  },
  "r_fib": {
   "mode": "fib",
   "section": "reading",
   "audio": false,
   "passage": "When Anaïs Tremblay moved into her apartment, the property manager handed her a welcome package that {{1}} a copy of the lease and a list of emergency contacts. The booklet explained how to {{2}} a maintenance request through the online portal. It also reminded tenants to report leaks early, {{3}}…",
   "options": [],
   "answerIndex": 0,
   "typed": true,
   "firstAnswer": "included",
   "gapPrompt": ""
  },
  "l_sst": {
   "mode": "typed",
   "section": "listening",
   "audio": true,
   "passage": "",
   "prompt": "",
   "words": ""
  },
  "summarize_written_text": {
   "mode": "typed",
   "section": "writing",
   "audio": false,
   "passage": "When Annika Sorensen took over as front office manager at a mid-sized resort on Vancouver Island, she inherited a staffing model that had barely changed in two decades. The property relied almost entirely on full-time, year-round employees, which kept payroll steady but left the resort scrambling during the summer peak and overstaffed through the quiet…",
   "prompt": "Read the passage and summarize it in 25 to 50 words, in a single sentence.",
   "words": "25-50 words"
  },
  "pte_describe_image": {
   "mode": "image",
   "section": "speaking",
   "audio": false,
   "prompt": "Look at the image below. In 25 seconds, prepare to describe it. Then speak for 40 seconds.",
   "diagram": {
    "title": "New Apprenticeship Registrations by Trade, 2024",
    "kind": "bar",
    "data": [
     {
      "label": "Electrician",
      "value": 8420
     },
     {
      "label": "Carpenter",
      "value": 6150
     },
     {
      "label": "Welder",
      "value": 4730
     },
     {
      "label": "Plumber",
      "value": 3980
     },
     {
      "label": "HVAC Technician",
      "value": 2610
     }
    ],
    "unit": "new apprentices",
    "source_note": "Compiled by program coordinator Anneli Virtanen, Provincial Trades Authority."
   },
   "scene": "",
   "imageRef": null
  },
  "l_mcq_multi": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "Good afternoon, passengers. This is an announcement for all travellers on the three-fifteen sailing to Nanaimo. Due to heavy swells in the Strait, we're experiencing a delay of approximately forty minutes. The boarding gate has also been changed from Gate Four to Gate Seven, located at the far end of the terminal near the food court. All vehicles must remain in the parking area until further notice, and drivers…",
   "prompt": "According to the announcement, which TWO of the following statements are correct?",
   "options": [
    "The delay is caused by fog near the terminal entrance.",
    "Drivers should move their vehicles out of the parking area right away.",
    "The sailing to Nanaimo is delayed by approximately forty minutes.",
    "Passengers should return to their vehicles immediately after checking in."
   ],
   "answerIndex": 0
  },
  "pte_read_aloud": {
   "mode": "read",
   "section": "speaking",
   "audio": false,
   "prompt": "Look at the text below. In 35 seconds, you must read it aloud.",
   "passage": "Anika began her electrical apprenticeship in Calgary last spring. To earn her certification, she must log thousands of supervised hours on real job sites and pass written exams. Her mentor checks each task carefully, explaining safety codes and wiring standards that protect both workers and the…",
   "prep": 35,
   "rec": 40
  },
  "l_smw": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "Before we wrap up the safety briefing, I want to remind all lifeguards that shift handovers need to be completed in writing. That means filling out the incident log and noting the current chemical readings before you leave the deck. If a reading is outside the acceptable range, you're required to notify the pool supervisor before your shift [BEEP]",
   "prompt": "Select the word or phrase that best completes the recording.",
   "options": [
    "ends",
    "begins",
    "changes",
    "improves"
   ],
   "answerIndex": 0
  },
  "l_mcq_single": {
   "mode": "listening",
   "section": "listening",
   "audio": true,
   "passage": "Hello, I'm calling from Clearbrook Animal Shelter. I'm reaching out because you submitted an adoption application for one of our dogs, a two-year-old border collie mix named Hector. I wanted to let you know that we've reviewed your application and we'd love to invite you in for a meet-and-greet this coming Saturday between ten and noon. Just so you know, Hector does best in homes without small children, and he'll…",
   "prompt": "What is the main purpose of this phone call?",
   "options": [
    "To invite the applicant to meet the dog they applied to adopt.",
    "To inform the caller that their adoption application has been rejected.",
    "To ask the applicant whether they have experience with border collies.",
    "To confirm that the dog has already been placed with another family."
   ],
   "answerIndex": 0
  },
  "rw_fib": {
   "mode": "fib",
   "section": "reading",
   "audio": false,
   "passage": "Starting a new job can feel overwhelming, but a well-structured onboarding programme helps employees adjust quickly. On the first day, new hires usually {{1}} a tour of the building and receive their equipment. Managers then {{2}} clear expectations so that everyone understands their…",
   "options": [
    "take",
    "make",
    "do",
    "have"
   ],
   "answerIndex": 0,
   "typed": false,
   "firstAnswer": "take",
   "gapPrompt": "Gap 1"
  },
  "l_fib": {
   "mode": "fib",
   "section": "listening",
   "audio": true,
   "passage": "Welcome to Ridgewood Hardware. This week we've got some excellent deals across the store. In the plumbing section, all {{1}} fittings are twenty percent off. If you're working on a renovation, our {{2}} insulation batts are back in stock and available in two standard widths. Don't forget to pick up…",
   "options": [],
   "answerIndex": 0,
   "typed": true,
   "firstAnswer": "copper",
   "gapPrompt": ""
  },
  "l_hiw": {
   "mode": "hiw",
   "section": "listening",
   "audio": true,
   "words": [
    "Most",
    "people",
    "don't",
    "realize",
    "they",
    "can",
    "claim",
    "costs",
    "for",
    "a",
    "workspace",
    "at",
    "home",
    "if",
    "they",
    "apply",
    "it",
    "regularly",
    "for",
    "their",
    "professional",
    "duties."
   ],
   "wrongIndex": 7
  },
  "l_wfd": {
   "mode": "dictation",
   "section": "listening",
   "audio": true,
   "answerText": "All passengers must remain seated until the vessel has docked."
  },
  "r_mcq_single": {
   "mode": "reading",
   "section": "reading",
   "audio": false,
   "passage": "To all residents of Birchgrove Court, please note an important change to our waste collection schedule. Starting the first week of October, the city will no longer accept mixed recycling in clear bags. Instead, each unit has been issued a blue rolling bin, which must be placed at the curb by 7 a.m. on collection day. Property manager Anneli Virtanen reminds tenants that glass and soft plastics are now handled…",
   "prompt": "What is the main purpose of this notice?",
   "options": [
    "To inform residents of new recycling rules and how to comply",
    "To announce that recycling collection has been cancelled entirely",
    "To advertise a cleaning service for the building lobbies",
    "To request that residents pay an increased monthly rent"
   ],
   "answerIndex": 0
  },
  "pte_asq": {
   "mode": "speak",
   "section": "speaking",
   "audio": true,
   "prompt": "You will hear a question. Please give a simple and short answer.",
   "passage": "",
   "prep": 0,
   "rec": 10
  },
  "r_reorder": {
   "mode": "reorder",
   "section": "reading",
   "audio": false,
   "paragraphs": [
    "A technician arrived the next afternoon and replaced a faulty thermostat within an hour.",
    "One cold morning, Ingrid noticed the heat in her apartment had stopped working entirely.",
    "Satisfied, she thanked him and confirmed the unit was holding a steady temperature.",
    "She emailed her property manager right away and described the problem in detail."
   ],
   "firstIndex": 1
  },
  "pte_respond_situation": {
   "mode": "speak",
   "section": "speaking",
   "audio": true,
   "prompt": "Listen to and read a description of a situation. Then respond.",
   "passage": "",
   "prep": 20,
   "rec": 40
  },
  "r_mcq_multi": {
   "mode": "reading",
   "section": "reading",
   "audio": false,
   "passage": "When Anneli Korhonen signed the lease for her first apartment in Halifax, the property manager walked her through several clauses she had skimmed over. The monthly rent of $1,450 included heat and water, but electricity was billed separately to the tenant. A refundable security deposit equal to half a month's rent was held in a trust account, and the manager confirmed it would be returned within fifteen days of…",
   "prompt": "Which of the following are supported by the text?",
   "options": [
    "The security deposit equalled a full month's rent",
    "Maintenance requests were submitted through an online portal",
    "Dogs were allowed with written approval",
    "Subletting required the landlord's consent"
   ],
   "answerIndex": 0
  },
  "write_email": {
   "mode": "typed",
   "section": "writing",
   "audio": false,
   "passage": "",
   "prompt": "You are organizing a one-day staff training session for your team and want to hold it at the Cedar Harbour Hotel in Halifax. Write an email to the events coordinator, Annika Vasquez, to request information and make a…",
   "words": "80-120 words"
  }
 }
};
export default EXAM_SCREENS;
